import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import * as action from "~/store/notifications/notificationsActions";
import qs from "qs";
import { Redirect } from "react-router-dom";
import { withTitle } from "~/components/common/molecules/TitleHelmet";

const NotificationDetailPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/desktop/pages/NotificationDetail"
    ),
  loading: LoadableLoading
});
const NotificationDetailPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/desktop/pages/NotificationDetail"
    ),
  loading: LoadableLoading
});

class DetectNotificationDetail extends Component {
  render() {
    const {
      device,
      notiDetail,
      IsAuthenticated,
      user_id,
      access_token,
      updateReadNotification
    } = this.props;
    if (IsAuthenticated && notiDetail && notiDetail.is_new) {
      updateReadNotification({ noti_id: notiDetail.id, user_id, access_token });
    }
    if (!notiDetail) {
      // if (device === "mobile") return <Redirect to="/thong-bao" />;
      // else
      return (
        <Redirect
          to={{
            pathname: "/user",
            state: { activeItem: 3 }
          }}
        />
      );
    }

    return (
      <React.Fragment>
        {device === "mobile" ? (
          <NotificationDetailPageMobile
            {...this.props}
            notiDetail={notiDetail}
          />
        ) : (
          <NotificationDetailPageDesktop
            {...this.props}
            notiDetail={notiDetail}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const {
    global: {
      device: { type }
    },
    user: {
      IsAuthenticated,
      info: { user_id, access_token }
    },
    notification: { data, total_new }
  } = state;

  const noti_id = parseInt(
    qs.parse(props.location.search, {
      ignoreQueryPrefix: true
    }).id
  );

  const notiDetail = data.find(noti => noti.id === noti_id);

  return {
    device: type,
    data,
    total_new,
    IsAuthenticated,
    user_id,
    access_token,
    notiDetail
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateReadNotification: ({ noti_id, user_id, access_token }) =>
      dispatch(
        action.updateReadNotification({ noti_id, user_id, access_token })
      )
  };
};

const NotificationDetailHelmet = withTitle({
  component: DetectNotificationDetail,
  title: "Medpro | Chi tiết thông báo"
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationDetailHelmet);
